import styled from '@emotion/styled'
import { SelectMenu } from 'components/patterns/Inputs'

export const StyledSelectMenu = styled(SelectMenu)`
  .ant-select {
    width: 100%;
  }
`

export const ItalicSpan = styled.span`
  font-style: italic;
`
export const Divider = styled.div`
  height: 1px;
  background: white;
`

export const DivisionDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-left: 5px;
`

export const EquationDiv = styled.div`
  display: flex;
  align-items: center;
`
